import { isSafeGraphQLClient } from "@safecoin/safe/graphql";
//#region src/query/client-utils.ts
const DEFAULT_QUERY_LIMIT = 50;
const MAX_EVENT_QUERY_PAGES = 10;
async function getAllObjects(client, ids) {
	if (ids.length === 0) return [];
	const { objects } = await client.core.getObjects({
		objectIds: ids,
		include: {
			content: true,
			previousTransaction: true,
			display: true
		}
	});
	return objects.filter((object) => !(object instanceof Error)).map((object) => ({
		...object,
		previousTransaction: object.previousTransaction ?? null,
		display: object.display ? {
			data: object.display.output,
			error: object.display.errors ? JSON.stringify(object.display.errors) : null
		} : void 0
	}));
}
async function queryEvents(client, eventType) {
	const order = isSafeGraphQLClient(client) ? "ascending" : "descending";
	const events = [];
	let cursor = null;
	for (let pageCount = 0; pageCount < MAX_EVENT_QUERY_PAGES; pageCount++) {
		const remaining = DEFAULT_QUERY_LIMIT - events.length;
		const page = await client.core.listEvents({
			filter: { eventType },
			limit: remaining,
			order,
			...cursor ? order === "descending" ? { before: cursor } : { after: cursor } : {}
		});
		events.push(...page.events.slice(0, remaining));
		if (!page.hasNextPage || events.length === DEFAULT_QUERY_LIMIT) break;
		if (!page.endCursor || page.endCursor === cursor) throw new Error("Event query did not return a cursor for the next page");
		cursor = page.endCursor;
	}
	return events.map((event) => ({ json: event.json }));
}
//#endregion
export { getAllObjects, queryEvents };

//# sourceMappingURL=client-utils.mjs.map